// ─── AVISO FLASH (admin) ──────────────────────────────────────
// 1) Limpia ?resultado de la URL para que al recargar NO se repita el aviso.
// 2) Auto-oculta el aviso tras unos segundos (con una salida suave).
(() => {
  "use strict";

  // 1) Limpiar el query param ?resultado sin recargar la página.
  const url = new URL(window.location.href);
  if (url.searchParams.has("resultado")) {
    url.searchParams.delete("resultado");
    const limpia = url.pathname + (url.search ? url.search : "") + url.hash;
    window.history.replaceState(null, "", limpia);
  }

  // 2) Auto-ocultar el aviso.
  const aviso = document.querySelector(".admin-aviso");
  if (!aviso) return;
  setTimeout(() => {
    aviso.classList.add("admin-aviso--saliendo");
    setTimeout(() => aviso.remove(), 320);
  }, 4000);
})();
